export default {
  de: {
    general: {
      yes: "Ja",
      no: "Nein",
      save_btn: 'Speichern',
      contact_btn: 'Kontakt',
      warning: 'Achtung',
      cancel: 'Abbrechen',
      send: 'Senden'
    },
    calculation_info: {
      active_calculation: 'Aktive Kalkulation'
    },
    my_events: {
      select_pdf: 'PDF Auswählen',
      no_pdf: 'Kein PDF verfügbar'
    },
    calc_overview: {
      save: "@:general.save_btn",
      warning: '@:general.warning',
      cancel: '@:general.cancel',
      overview_headline: "Projektübersicht",
      not_saved: "nicht gespeichert",
      create_pdf: "PDF erzeugen",
      facts: 'Fakten',
      fact: 'Fakt',
      answer: 'Antwort',
      jump_to_text: 'Sie können die blau markierten Links benutzen, um zur entsprechenden Frage zu springen.',
      calculation: 'Kalkulation',
      subtotal: 'Zwischensumme',
      total: 'Gesamtkosten',
      inkl: 'Alle Preise exklusive USt.',
      jump_to_position: 'Sie können zu der von Ihnen ausgewählten Position in Ihrer Kalkulation springen. Alle Fragen, die nach der ausgewählten Position gestellt wurden, werden dann zurückgesetzt und müssen erneut beantwortet werden.',
      next: 'weiter',
      before_pdf: "Bevor Sie eine PDF erzeugen können, müssen Sie die Kalkulation speichern. Bitte geben Sie unten einen Namen für die Kalkulation ein."
    },
    calculation_footer: {
      total: 'Gesamtkosten',
      net: 'netto',
      cost_overview: 'Kostenübersicht',
      subtotal: 'Zwischensumme',
      show_overview: 'Übersicht anzeigen',
      request_advice: 'Beratung anfordern',
      request_a_quote: 'Angebot anfordern',
      save_calculation: 'Kalkulation speichern',
      calculation_saved: 'Gespeichert',
      save_first: 'Bevor Sie ein Angebot anfordern können, müssen Sie die Kalkulation speichern. Bitte geben Sie unten einen Namen für die Kalkulation ein'
    },
    answers: {
      change_warning_msg: 'Durch das Verändern dieser Frage werden alle Folgefragen zurückgesetzt.'
    },
    fair_module: {
      place: 'Ort',
      branchen: 'Branchen',
      date: 'Datum',
      date_value: '%{begin} bis %{end} (%{duration} Tage)',
      fair_not_found: 'Messe nicht in der Datenbank enthalten.',
      next_without_auma: 'Weiter ohne AUMA-Daten.',
      no_fair_selected: 'keine Auma Messe ausgewählt',
      placeholder: 'Veranstaltung suchen'
    },
    additional_results_module: {
      add_entry: 'Eintrag ergänzen',
      placeholder: 'Bitte Kostenart eintragen'
    },
    location_module: {
      placeholder: 'Google Maps Deutschland Suchmaske'
    },
    modals: {
      save_calculation: {
        save_calculation_headline:  'Kalkulation speichern',
        save_calculation_button:  'Jetzt speichern',
        save_calculation_default_msg: "Bitte erfassen Sie einen Arbeitstitel für Ihre Kalkulation. Änderungen werden automatisch gespeichert.",
      },
      editable_variable: {
        adjust_value: 'Wert anpassen',
        min: 'min',
        max: 'max',
        save: "@:general.save_btn",
        cancel: '@:general.cancel',
      },
      login: {
        title: 'Login',
        msg: 'Bitte melden Sie sich an, um diese Funktion zu nutzen.',
        cancel: 'Abbrechen',
        ok: 'Zum Login'
      },
      lose_calculation_warning: {
        title: 'Vorsicht',
        msg: 'Die aktuelle Kalkulation wurde noch nicht gespeichert. <br> Die Kalkulation wird gelöscht, wenn Sie sie verlassen, ohne zu speichern.',
        msg_login: 'Wenn Sie die Kalkulation speichern möchten, melden Sie sich bitte an.',
        ok_btn: 'Kalkulation Speichern',
        login_btn: 'Zum Login',
        continue_without_save_btn: 'Weiter ohne Speichern'
      },
      pdf: {
        download_btn: 'Download'
      },
      warning: '@:general.warning',
      cancel: '@:general.cancel',
      delete_all_answers_warning: 'Änderungen verursachen die Löschung aller nachfolgenden Antworten',
      allow_changes: 'Änderungen erlauben',
      reset_value_to:  'Wert auf %{value} zurücksetzen',      
    },
    contact: {
      contact_headline: 'Kontakt'
    }
  },
  en: {
    general: {
      yes: "Yes",
      no: "No",
      save_btn: 'Save',
      contact_btn: 'Contact',
      warning: 'Warning',
      cancel: 'Cancel',
      send: 'Send'
    },
    calculation_info: {
      active_calculation: 'Active calculation'
    },
    my_events: {
      select_pdf: 'Select PDF',
      no_pdf: 'No PDF available'
    },
    calc_overview: {
      save: "@:general.save_btn",
      warning: '@:general.warning',
      cancel: '@:general.cancel',
      overview_headline: "Project overview",
      not_saved: "nicht gespeichert",
      create_pdf: "Create PDF",
      facts: 'Facts',
      fact: 'Fact',
      answer: 'Answer',
      jump_to_text: 'You may use the links marked in blue to jump to the respective question.',
      calculation: 'Calculation',
      subtotal: 'Subtotal',
      total: 'Total costs',
      inkl: 'All prices are quoted exclusive of VAT',
      jump_to_position: 'Within the calculation, you may jump to the selected position. All questions asked after the selected position, will be reset and have to be answered again.',
      next: 'Next',
      before_pdf: "Before creating a PDF, you have to save your calculation. Please enter a name for the calculation below."
    },
    calculation_footer: {
      total: 'Total costs',
      net: 'net',
      cost_overview: 'Cost overview',
      subtotal: 'Subtotal',
      show_overview: 'Show Overview',
      request_advice: 'Request guidance',
      request_a_quote: 'Request quote',
      save_calculation: 'Save calculation',
      calculation_saved: 'Saved',
      save_first: 'Before requesting a quote, please save your calculation. Please enter a name for your calculation.'
    },
    answers: {
      change_warning_msg: 'By changing this question, all following questions will be reset.'
    },
    fair_module: {
      place: 'Place',
      branchen: 'Industries',
      date: 'Date',
      date_value: '%{begin} bis %{end} (%{duration} Tage)',
      fair_not_found: 'trade show not included in our database.',
      next_without_auma: 'Continue without AUMA data.',
      no_fair_selected: 'No Auma trade show selected',
      placeholder: 'Find events'
    },
    additional_results_module: {
      add_entry: 'Complement entry',
      placeholder: 'Please enter cost type'
    },
    location_module: {
      placeholder: 'Google Maps Germany search mask'
    },
    modals: {
      save_calculation: {
        save_calculation_headline:  'Save calculation',
        save_calculation_button:  'Save now',
        save_calculation_default_msg: "Please determine a working title for your calculation. Changes will be saved automatically.",
      },
      editable_variable: {
        adjust_value: 'Adjust value',
        min: 'min',
        max: 'max',
        save: "@:general.save_btn",
        cancel: '@:general.cancel',
      },
      login: {
        title: 'Log-in',
        msg: 'Please log in in order to use this function.',
        cancel: 'Cancel',
        ok: 'Log-in'
      },
      lose_calculation_warning: {
        title: 'Warning',
        msg: 'The current calculation has not been saved yet. <br> The calculation will be deleted, if you leave without saving it.',
        msg_login: 'Please log in in order to save the calculation.',
        ok_btn: 'Save calculation',
        to_login_btn: 'To log-in',
        login_btn: 'Login',
        continue_without_save_btn: 'Continue without saving'
      },
      pdf: {
        download_btn: 'Download'
      },
      warning: '@:general.warning',      
      cancel: '@:general.cancel',
      delete_all_answers_warning: 'Changes delete all following answers',
      allow_changes: 'Allow changes',
      reset_value_to:  'Reset value to %{value}',      
    },
    contact: {
      contact_headline: 'Contact'
    }
  },
}